import React from 'react';
import { useAPIContext } from '../../../context/api';
import { AvatarsAPI } from '../../../../../constructs/avatars/interface';

export const useGetAvatarProjectDetails = () => {
  const { callEndpoint } = useAPIContext();

  const getProjectDetails = React.useCallback(
    async (projectId: string) => {
      try {
        const res = await callEndpoint<AvatarsAPI, 'get-avatar-project-details'>(
          'avatars',
          `/project/${projectId}`,
          'GET'
        );
        if (!res) throw new Error('Respuesta del servidor inesperada');
        return res;
      } catch (error: any) {
        console.error('Error al obtener detalles del proyecto:', error);
        return null;
      }
    },
    [callEndpoint]
  );

  return { getProjectDetails };
};
